// SXAlertsContainer.tsx
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import { SXAlert } from "./SXAlert";
import { removeAlert } from "../../../features/ui/uiSlice";

export const SXAlertsContainer = () => {
  const dispatch = useDispatch();
  const alerts = useSelector((state: RootState) => state.uiSlice.alerts);

  return (
    <>
      {alerts.map((a, index) => {
        const offset = 5 + index * 5; // 5%, 10%, 15%, ...

        return (
          <SXAlert
            key={a.id}
            id={a.id}
            status={a.status}
            text={a.text}
            context={a.context}
            varient={a.type}
            keep={a.keep}
            offset={offset}
            onClose={() => dispatch(removeAlert(a.id))}
          />
        );
      })}
    </>
  );
};
